import Cookies from 'js-cookie'

/**
 * Secure cookie storage utility with appropriate security configurations
 * - Secure: Only sent over HTTPS when env is not "DEV"
 * - SameSite: Strict to prevent CSRF attacks
 * - Expires: 7 days for tokens, 30 days for refresh tokens
 */

const env = window.environment || 'PROD'
const isSecure = env !== 'DEV'

const cookieDefaults = {
    secure: isSecure, // Only send over HTTPS when not in development environment
    sameSite: 'Strict', // Prevent CSRF attacks
    path: '/', // Available throughout the app
}

export const cookieStorage = {
    /**
     * Set a cookie with security attributes
     */
    setItem: (key, value, expires) => {
        const expiryDays = expires || 7 // Default 7 days
        Cookies.set(key, value, {
            ...cookieDefaults,
            expires: expiryDays,
        })
    },

    /**
     * Get a cookie value
     */
    getItem: (key) => {
        return Cookies.get(key)
    },

    /**
     * Remove a cookie
     */
    removeItem: (key) => {
        Cookies.remove(key, { path: '/' })
    },

    /**
     * Check if a cookie exists
     */
    hasItem: (key) => {
        return Cookies.get(key) !== undefined
    },

    /**
     * Clear all auth-related cookies
     */
    clear: () => {
        const authKeys = ['token', 'refreshToken']
        authKeys.forEach((key) => cookieStorage.removeItem(key))
    },
}